import { render, staticRenderFns } from "./InfoEdit.vue?vue&type=template&id=252bd012&scoped=true&"
import script from "./InfoEdit.vue?vue&type=script&lang=js&"
export * from "./InfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./InfoEdit.vue?vue&type=style&index=0&id=252bd012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bd012",
  null
  
)

export default component.exports